/**
 * Created by
 * @author <yunishev@sotal.tv> Art Yunishev
 * on 02.08.2016.
 */

import ParentalReducer from './reducer-parental';

export default ParentalReducer;



// WEBPACK FOOTER //
// ./src/reducers/parental/index.js